var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.appStyle),attrs:{"id":"main"}},[_c('NavBar'),_c('v-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }